'use client';

import React, { createContext, useState, useContext, useEffect } from 'react';

type SubscriptionInfo = {
  active: boolean;
  current_period_end: number | null;
  current_period_start: number | null;
  interval: string;
  status: string;
  cancel_at_period_end: boolean;
  trial_end?: number | null;
  plan_name?: string | null;
  stripe_subscription_id?: string | null;
};

type SubscriptionContextType = {
  subscriptionInfo: SubscriptionInfo | null;
  setSubscriptionInfo: React.Dispatch<React.SetStateAction<SubscriptionInfo | null>>;
  subscription: SubscriptionInfo | null; // Alias for convenience
};

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
};

export const SubscriptionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [subscriptionInfo, setSubscriptionInfo] = useState<SubscriptionInfo | null>(null);

  return (
    <SubscriptionContext.Provider value={{ 
      subscriptionInfo, 
      setSubscriptionInfo,
      subscription: subscriptionInfo // Alias for convenience
    }}>
      {children}
    </SubscriptionContext.Provider>
  );
};